module.exports = __webpack_public_path__ + "static/media/VectorArrowLeft.0edb184f.svg";